const firebaseConfig = {
    apiKey: "AIzaSyBx1TigZjtUsuyvB_vtWsTYxjnQu6E7rgU",
    authDomain: "dental-services-22ba9.firebaseapp.com",
    projectId: "dental-services-22ba9",
    storageBucket: "dental-services-22ba9.appspot.com",
    messagingSenderId: "1088079841830",
    appId: "1:1088079841830:web:0cc330593a0789f33374e7"
};
export default firebaseConfig;